import React from 'react';

export default function QuestionModal({ open, value, onChange, onCancel, onAsk, disabled }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>Ask a question about this video</h3>
        <input
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Type your question..."
          className="modal-input"
          autoFocus
        />
        <div className="modal-actions">
          <button onClick={onCancel}>Cancel</button>
          <button onClick={onAsk} disabled={disabled}>Ask</button>
        </div>
      </div>
    </div>
  );
} 
